module.exports = __webpack_public_path__ + "img/thumbnail_HighlandCattle_m_melanistic.1aab07e6.png";